"use strict";

exports.__esModule = true;
exports.ReportTagController = ReportTagController;
var _react = _interopRequireWildcard(require("react"));
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ReportTagController(_ref) {
  var children = _ref.children;
  var dataAccessor = _react["default"].useContext(_DataAccessorContext.DataAccessorContext);
  var _useState = (0, _react.useState)(true),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = (0, _react.useState)([]),
    data = _useState2[0],
    setData = _useState2[1];
  (0, _react.useEffect)(function () {
    dataAccessor.getReportTags().then(function (response) {
      setLoading(false);
      setData(response);
    })["catch"](function (err) {
      setLoading(false);
      console.error("Error making request", err);
    });
  }, []);
  return children({
    loading: loading,
    data: data
  });
}